function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    }
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

/**
 * Splide
 */
document.addEventListener( 'DOMContentLoaded', function() {

    if (! document.querySelector('.splide')) {
        return;
    }

    var splide = new Splide( '.splide' );
    splide.mount();
} );

/* Mattress Exploder */
window.onload = function () {

    if (! document.querySelector('.mattress-container') ) {
        return;
    }

    function getViewPercentage(element) {

        let addStartOffset = false;
        let addOffsetValue = 20;
        let addEndOffset = false

        let startsEntering = true;
        let startsExiting = false;

        let rootElement = document.documentElement;

        var scrollHeight = rootElement.scrollHeight,
            visibleHeight = rootElement.clientHeight;

        var elementRect = element.getBoundingClientRect();
        var offsetStartPerc = (addStartOffset ? addOffsetValue : 0) / 100;
        var offsetEndPerc = (addEndOffset ? endOffsetValue : 0) / 100; // flip the offset percentages depending on start / exit type

        offsetStartPerc = startsEntering ? offsetStartPerc : 1 - offsetStartPerc;
        offsetEndPerc = startsExiting ? offsetEndPerc : 1 - offsetEndPerc;

        var offsetElementTop = elementRect.top + Math.min(elementRect.height * offsetStartPerc, visibleHeight);
        var offsetElementBottom = elementRect.top + elementRect.height * offsetEndPerc;
        var offsetHeight = offsetElementBottom - offsetElementTop;
        var fixedScrollHeight = Math.min(visibleHeight + offsetHeight, scrollHeight);
        var fixedScrollTop = Math.min(Math.max(0, visibleHeight - offsetElementTop), fixedScrollHeight);
        var fixedScrollPerc = fixedScrollTop / fixedScrollHeight;

        return Math.round(fixedScrollPerc * 100);
    }

    lax.init()

    lax.addDriver('scrollParent', function () {
        return getViewPercentage(document.querySelector('.mattress-container'));
    });

    let layers = document.querySelectorAll('.mattress-layer');

    for (let index = 0; index < layers.length; index++) {
        const element = layers[index];

        lax.addElement(element, {
            scrollParent: {
                translateY: [
                    [20, 40],
                    [0, element.dataset.lax]
                ]
            }
        })
    }
}


class HeaderDrawer extends HTMLElement {
    constructor() {
        super();

        this.isOpen = false;
        this.drawer = this.querySelector('.menu-drawer');

        document.addEventListener('keyup', this.close.bind(this));

        this.querySelectorAll('[data-menu-trigger="open"]').forEach((trigger) => {
            trigger.addEventListener('click', this.open.bind(this));
        });

        this.querySelectorAll('[data-menu-trigger="close"]').forEach((trigger) => {
            trigger.addEventListener('click', this.close.bind(this));
        });
    }

    open(e) {
        this.drawer.classList.add('menu-drawer--open');
        document.querySelector('body').classList.add('overflow-hidden');
        this.isOpen = true;
    }

    close(e) {
        if (e.type === "keyup" && e.key !== "Escape") {
            return;
        }

        this.drawer.classList.remove('menu-drawer--open')
        document.querySelector('body').classList.remove('overflow-hidden')
        this.isOpen = false;
    }
}

customElements.define('header-drawer', HeaderDrawer);

customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains('button--loading')) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('button--loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                this.handleErrorMessage(response.description);
                return;
            }
            this.cartNotification.renderContents(response);

            this.handleSuccessMessage('Item added to your cart');

        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            submitButton.classList.remove('button--loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
    }

    handleSuccessMessage(successMessage = false) {
        this.successMessageWrapper = this.successMessageWrapper || this.querySelector('.product-form__success-message-wrapper');
        this.successMessage = this.successMessage || this.successMessageWrapper.querySelector('.product-form__success-message');

        this.successMessageWrapper.toggleAttribute('hidden', !successMessage);

        if (successMessage) {
            this.successMessage.textContent = successMessage;
        }
    }
});

class CartNotification extends HTMLElement {
    constructor() {
        super();

        this.notification = document.getElementById('cart-notification');
        this.header = document.querySelector('sticky-header');
        this.onBodyClick = this.handleBodyClick.bind(this);

        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
        );
    }

    open() {
        this.notification.classList.add('animate', 'active');

        this.notification.addEventListener('transitionend', () => {
            this.notification.focus();
            trapFocus(this.notification);
        }, { once: true });

        document.body.addEventListener('click', this.onBodyClick);
    }

    close() {
        this.notification.classList.remove('active');

        document.body.removeEventListener('click', this.onBodyClick);
    }

    renderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section => {
            document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));

        if (this.header) this.header.reveal();
        this.open();
    }

    getSectionsToRender() {
        return [
            // {
            //     id: 'cart-notification-product',
            //     selector: `#cart-notification-product-${this.productId}`,
            // },
            // {
            //     id: 'cart-notification-button'
            // },
            {
                id: 'cart-icon-bubble'
            }
        ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-notification', CartNotification);



class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
            const id = `price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(`price-${this.dataset.section}`);

            if (price) price.classList.remove('visibility-hidden');
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
        if (this.sliderItemsToShow.length === 0) return;
        this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }}));
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0])) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderLastItem)) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
}

customElements.define('slider-component', SliderComponent);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
            );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

class ProductTabs extends HTMLElement {
    constructor() {
        super();

        this.querySelector('.product-tabs__nav').addEventListener('click', (e) => {

            if (e.target.matches('a')) {
                e.preventDefault();
                this.openTab(e.target.getAttribute('href'));
            }

        }, false);
    }

    clearOpenTabs() {
        this.querySelector('.product-tabs__tab--active').classList.remove('product-tabs__tab--active');
        this.querySelector('.product-tabs__link--active').classList.remove('product-tabs__link--active');
    }

    openTab(target) {
        let tab = this.querySelector('.product-tabs__tabs li' + target + '');
        let link = this.querySelector('.product-tabs__nav [href="' + target + '"]')

        this.clearOpenTabs();

        tab.classList.add('product-tabs__tab--active');
        link.classList.add('product-tabs__link--active');
    }

}
customElements.define('product-tabs', ProductTabs);
